import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/components/ModelHero")
);

const ModelpageHeroEditConfig = {
  emptyLabel: "Modelpage Hero",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => ({
  component: "ModelHero",
  props: {
    ...props,
    slides: props.slides.map((slide) => ({
      ...slide,
      height: window && window.CQ ? "600px" : undefined,
    })),
  },
});

const ModelpageHero = (props) => {
  const data = transformData(props);
  return <Component {...data.props} />;
};

export default withAemIntegration("lexus/components/modelpage-hero")(
  ModelpageHero,
  ModelpageHeroEditConfig
);
